export const attendanceTypesOptions = [
  { value: 1, label: 'Present', color: 'presentColor' },
  { value: 2, label: 'Absent', color: 'absentColor' },
  { value: 3, label: 'Leave', color: 'leaveColor' },
  { value: 4, label: 'Excused', color: 'excusedColor' },
  { value: 5, label: 'Holiday Out', color: 'holidayOutColor' },
  { value: 6, label: 'Sick Leave', color: 'sickLeaveColor' },
  { value: 7, label: 'Off Day', color: 'offDayColor' },
  { value: 8, label: 'Training', color: 'trainingColor' },
  { value: 9, label: 'Vacation', color: 'vacationColor' },
  { value: 10, label: 'Maternity Leave', color: 'maternityLeaveColor' },
  { value: 11, label: 'Holiday In', color: 'holidayInColor' },
  { value: 12, label: 'Unknown', color: 'absentColor' },
]

export const attendanceTypesOptionsWithTime = [
  { value: 1, label: 'Present', color: 'presentColor' },
  { value: 111, label: 'Present (time input)', color: 'presentColor' },
  { value: 2, label: 'Absent', color: 'absentColor' },
  { value: 3, label: 'Leave', color: 'leaveColor' },
  { value: 4, label: 'Excused', color: 'excusedColor' },
  { value: 444, label: 'Excused (time input)', color: 'excusedColor' },
  { value: 5, label: 'Holiday Out', color: 'holidayOutColor' },
  { value: 6, label: 'Sick Leave', color: 'sickLeaveColor' },
  { value: 7, label: 'Off Day', color: 'offDayColor' },
  { value: 8, label: 'Training', color: 'trainingColor' },
  { value: 888, label: 'Training (time input)', color: 'trainingColor' },
  { value: 9, label: 'Vacation', color: 'vacationColor' },
  { value: 10, label: 'Maternity Leave', color: 'maternityLeaveColor' },
  { value: 11, label: 'Holiday In', color: 'holidayInColor', exception: true },
]

export const monthsOptions = [
  { value: 0, label: 'January' },
  { value: 1, label: 'February' },
  { value: 2, label: 'March' },
  { value: 3, label: 'April' },
  { value: 4, label: 'May' },
  { value: 5, label: 'June' },
  { value: 6, label: 'July' },
  { value: 7, label: 'August' },
  { value: 8, label: 'September' },
  { value: 9, label: 'October' },
  { value: 10, label: 'November' },
  { value: 11, label: 'December' },
]
